import * as React from 'react';
import {
  BookIcon,
  CuboidIcon
} from 'lucide-react';

import { routes } from '@workspace/routes';
import {
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  TikTokIcon,
  XIcon
} from '@workspace/ui/components/brand-icons';

export const MENU_LINKS = [
  {
    title: 'Preise',
    href: routes.marketing.Pricing,
    external: false
  },
  {
    title: 'Blog',
    href: routes.marketing.Blog,
    external: false
  },
  // {
  //   title: 'Über uns',
  //   href: routes.marketing.Story,
  //   external: false
  // },
  {
    title: 'Kontakt',
    href: routes.marketing.Contact,
    external: false
  }
];

export const FOOTER_LINKS = [
  {
    title: 'Navigation',
    links: [
      { name: 'Preise', href: routes.marketing.Pricing, external: false },
      { name: 'Blog', href: routes.marketing.Blog, external: false },
      // { name: 'Über uns', href: routes.marketing.Story, external: false },
      { name: 'Kontakt', href: routes.marketing.Contact, external: false }
    ]
  },
  {
    title: 'Rechtliches',
    links: [
      {
        name: 'Impressum',
        href: routes.marketing.Impressum,
        external: false
      },
      {
        name: 'AGB',
        href: routes.marketing.TermsOfUse,
        external: false
      },
      {
        name: 'Datenschutz',
        href: routes.marketing.PrivacyPolicy,
        external: false
      },
      {
        name: 'Cookie-Richtlinie',
        href: routes.marketing.CookiePolicy,
        external: false
      }
    ]
  }
];

export const SOCIAL_LINKS = [
  {
    name: 'X (formerly Twitter)',
    href: '~/',
    icon: <XIcon className="size-4 shrink-0" />
  },
  {
    name: 'LinkedIn',
    href: '~/',
    icon: <LinkedInIcon className="size-4 shrink-0" />
  },
  {
    name: 'Facebook',
    href: '~/',
    icon: <FacebookIcon className="size-4 shrink-0" />
  },
  {
    name: 'Instagram',
    href: '~/',
    icon: <InstagramIcon className="size-4 shrink-0" />
  },
  {
    name: 'TikTok',
    href: '~/',
    icon: <TikTokIcon className="size-4 shrink-0" />
  }
];

export const DOCS_LINKS = [
  {
    title: 'Getting Started',
    icon: <CuboidIcon className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      {
        title: 'Introduction',
        href: '/docs',
        items: []
      },
      {
        title: 'Dependencies',
        href: '/docs/dependencies',
        items: []
      }
    ]
  },
  {
    title: 'Guides',
    icon: <BookIcon className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      {
        title: 'Using MDX',
        href: '/docs/using-mdx',
        items: []
      }
    ]
  }
];
